export enum BeneficiaryApiUrls {
  Beneficiaries = "/v2/Beneficiaries",
  BeneficiaryRename = "/v2/Beneficiaries/:beneficiaryId/Name",
  BeneficiaryVisibility = "/v2/Beneficiaries/:beneficiaryId/Visibility",
  AttachmentValidation = "/v2/Beneficiaries/Entries/Validations",
  BeneficiaryAccount = "/v2/Beneficiaries/:beneficiaryId/Entries/Accounts",
  BeneficiaryAccountItem = "/v2/Beneficiaries/:beneficiaryId/Entries/Accounts/:beneficiaryEntryId",
  BeneficiaryCard = "/v2/Beneficiaries/:beneficiaryId/Entries/Cards",
  BeneficiaryCardItem = "/v2/Beneficiaries/:beneficiaryId/Entries/Cards/:beneficiaryEntryId",
  BeneficiaryDetails = "/v2/Beneficiaries/Details",
}

export enum Paths {
  Beneficiaries = "beneficiaries",
  CreateBeneficiary = "create",
}

export enum BeneficiaryVisibilityType {
  Shared = "Shared",
  Private = "Private",
  All = "All",
}

export enum AttachmentType {
  Account = "account",
  Card = "card",
}

export enum BeneficiaryKeys {
  Accounts = "accounts",
  Cards = "cards",
}

export enum BeneficiaryAttachmentKeys {
  Number = "number",
}

export enum AttachmentNetwork {
  VISA = "Visa",
  MASTERCARD = "MasterCard",
  ARCA = "Arca",
  ACCOUNT = "Account",
}
